/* eslint-disable */
import { inject, injectable } from "inversify";
import type { CustomAxiosRequestConfig } from "axios-auth-refresh/dist/utils";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import { IAuthApi } from "./IAuthApi";
import { UserCredentials, SignedInUser } from "@/models/auth";
import { RegisterOrganizationDto } from "@/models/organization/RegisterOrganizationDto";

@injectable()
export class AuthApi implements IAuthApi {
  @inject(SERVICES_TYPES.HTTP_CLIENT)
  private client: HttpClient;

  private readonly baseUrl = "/auth";

  // @ts-ignore
  private readonly configs: CustomAxiosRequestConfig = {
    skipAuthRefresh: true,
    withCredentials: true
  };

  async signIn(credentials: UserCredentials): Promise<SignedInUser> {
    const fullUrl = `${this.baseUrl}/signin`;
    const { data } = await this.client.post<SignedInUser>(
      fullUrl,
      { ...credentials, isAdminAccess: true },
      this.configs
    );
    return data;
  }

  async register(registerData: RegisterOrganizationDto): Promise<SignedInUser> {
    const fullUrl = `${this.baseUrl}/register`;
    const { data } = await this.client.post<SignedInUser>(fullUrl, registerData, this.configs);
    return data;
  }
}
